import React from "react";
import {
  Accordion,
  SliceConfig,
  Grid,
  IntersectionAnimation
} from "~components";
import cn from "classnames";
import * as styles from "./styles.module.scss";

const AccordionGroup = ({ data: { title, accordionBlocks, sliceConfig } }) => (
  <article>
    <SliceConfig config={sliceConfig}>
      <Grid narrowContent>
        <h2 className={cn(`h2`, styles.title)}>{title}</h2>
        {accordionBlocks?.map((accordion, i) => (
          <IntersectionAnimation animation="fadeGrow" delay={i * 100} key={i}>
            <Accordion title={accordion.title} content={accordion.content} />
          </IntersectionAnimation>
        ))}
      </Grid>
    </SliceConfig>
  </article>
);

export default AccordionGroup;
